// Comisiones de las OTAs (7-oct-2026). «Lo que te llega» en la ficha de la reserva
// (components/Reservas/PayData.vue): total − comisión de la OTA − IVA de la comisión.
// Placeholders: {channel} nombre del canal, {rate} y {vat} porcentajes ya formateados,
// {base} y {amount} importes ya formateados, {unit} tipo de habitación.
// Espacios finos/insecables antes de « : » y dentro de « … », como manda el francés.
export const otaNet = {
  title: "Ce que vous recevez",
  gross: "Total de la réservation",
  grossOnChannel: "Total de la réservation sur {channel}",
  grossOfUnit: "Total {unit}",
  commission: "Commission et frais de {channel} ({rate}\u00a0%)",
  commissionOfBase: "Commission et frais de {channel} ({rate}\u00a0% de {base})",
  commissionReal: "Commission {channel} (communiquée par le canal)",
  vat: "TVA sur la commission ({vat}\u00a0%)",
  net: "Vous recevez (env.)",
  howItWorks: "Comment c'est calculé",
  infoEstimate: "Estimation faite avec les pourcentages de «\u00a0Commissions des OTA\u00a0» de l'hébergement. L'OTA peut virer un montant légèrement différent (arrondis, promotions, frais de paiement).",
  infoBase: "La taxe de séjour et la caution ne paient pas de commission.",
  infoReal: "{channel} a communiqué la commission de cette réservation. La TVA sur la commission est une estimation faite avec le pourcentage de «\u00a0Commissions des OTA\u00a0»\u00a0: ce que vous recevez reste donc approximatif.",
  infoRealNoVat: "{channel} a communiqué la commission de cette réservation. Le virement peut tout de même varier un peu (arrondis, frais de paiement).",
  airbnbNet: "Airbnb verse déjà le montant net\u00a0: ce que vous voyez, c'est ce que vous recevez.",
  apart: "N'inclut pas {amount} encaissés à part\u00a0: cela ne passe pas par {channel}.",
  theChannel: "l'OTA",
};
